const STORAGE_KEY = 'cst-sidebar-width'
const STORAGE_KEY_AUTOHIDE = 'cst-sidebar-autohide'
const MIN_WIDTH = 385
const DEFAULT_WIDTH = 385

const ui = {
  namespaced: true,
  state: () => ({
    sidebarOpen: false,
    sidebarWidth: Math.max(
      MIN_WIDTH,
      parseInt(localStorage.getItem(STORAGE_KEY) || DEFAULT_WIDTH, 10)
    ),
    // Off unless the user explicitly turned it on, so the default stays the
    // current behaviour: the pane keeps standing open after a nav click.
    sidebarAutoHide: localStorage.getItem(STORAGE_KEY_AUTOHIDE) === 'true',
  }),
  mutations: {
    setSidebarOpen(state, value) {
      state.sidebarOpen = value
    },
    setSidebarWidth(state, value) {
      state.sidebarWidth = value
      localStorage.setItem(STORAGE_KEY, value)
    },
    setSidebarAutoHide(state, value) {
      state.sidebarAutoHide = value
      localStorage.setItem(STORAGE_KEY_AUTOHIDE, value)
    },
  },
  actions: {
    openSidebar({ commit }) {
      commit('setSidebarOpen', true)
    },
    closeSidebar({ commit }) {
      commit('setSidebarOpen', false)
    },
    resizeSidebar({ commit }, width) {
      commit('setSidebarWidth', width)
    },
    setSidebarAutoHide({ commit }, value) {
      commit('setSidebarAutoHide', value)
    },
  },
  getters: {
    sidebarOpen: (state) => state.sidebarOpen,
    sidebarWidth: (state) => state.sidebarWidth,
    sidebarAutoHide: (state) => state.sidebarAutoHide,
  },
}

export default ui
